import React, { useEffect, useRef, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Divider,
  IconButton,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";

import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";

import DeleteIcon from "@mui/icons-material/Delete";
// import "./ImagesForm.scss";
import { toast } from "react-toastify";
import { Confirm } from "notiflix";
// import { ImageGalleryRow } from "../../../../../../CustomComponents/ImageGalleryRow/ImageGalleryRow";
import {
  deleteAttachment,
  getAttachments,
  //   uploadAttachment,
} from "../../../api/ApiAttachments";
import DownloadIcon from "@mui/icons-material/Download";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";

export const ImageGalleryRow = ({
  handleUpload,
  uuid,
  referenced_by_type,
  canDelete = false,
}) => {
  const { t } = useTranslation("main");
  const containerRef = useRef(null);
  const fileInputRef = useRef(null);

  const imageSize = 80;
  const [hiddenCount, setHiddenCount] = useState(0);

  // const [attachments, setAttachments] = useState(sampleImages);
  const [attachments, setAttachments] = useState([]);
  const [visibleImages, setVisibleImages] = useState([]);
  const [actualMax, setActualMax] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);

  const fetchAttachments = async () => {
    try {
      const newAttachments = await getAttachments(uuid, referenced_by_type);
      setAttachments(newAttachments);
    } catch (error) {
      console.error("Error fetching attachments:", error);
    }
  };

  useEffect(() => {
    fetchAttachments();
  }, []);

  useEffect(() => {
    const updateSizes = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const gapSize = 16; // 1rem en píxeles (ajústalo si usas otra unidad)
        const maxImages = Math.floor(
          (containerWidth + gapSize) / (imageSize + gapSize)
        );

        // const maxImages = Math.floor(containerWidth / imageSize);
        const newActualMax = Math.max(1, maxImages - 1); // Reservamos un espacio para el botón de agregar

        if (attachments.length > newActualMax) {
          setActualMax(newActualMax);
          setVisibleImages(attachments.slice(0, newActualMax - 1));
          setHiddenCount(attachments.length - newActualMax);
        } else {
          setVisibleImages(attachments);
          setHiddenCount(0);
        }
      }
    };

    updateSizes();
    window.addEventListener("resize", updateSizes);
    return () => window.removeEventListener("resize", updateSizes);
  }, [attachments]);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      // setSelectedFile(file);

      const toast_id = toast.loading(`${t("uploading_image")}...`, {
        position: "top-right",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      await handleUpload(referenced_by_type)(file);

      toast.update(toast_id, {
        render: t("image_uploaded_successfully"),
        type: "success",
        isLoading: false,
        autoClose: 5000,
      });

      // Limpiar el input para permitir subir la misma imagen otra vez si es necesario
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      fetchAttachments();
    }
  };

  if (!handleUpload && attachments.length === 0) return;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "0.5rem",
          overflow: "hidden",
          width: "100%",
          alignItems: "center",
        }}
      >
        <Typography style={{ whiteSpace: "nowrap" }}>
          {t(referenced_by_type)}
        </Typography>
        <Divider
          style={{
            width: "100%",
          }}
        />
      </div>
      <div
        ref={containerRef}
        style={{
          display: "flex",
          gap: "1rem",
          overflow: "hidden",
          width: "100%",
        }}
      >
        {handleUpload ? (
          <>
            {/* // Botón de agregar nueva imagen */}
            <div
              style={{
                width: imageSize,
                height: imageSize,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #ccc",
                cursor: "pointer",
                borderRadius: "5px",
              }}
              onClick={() => fileInputRef.current.click()}
            >
              <AddIcon style={{ fontSize: 32, color: "#777" }} />
            </div>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </>
        ) : (
          visibleImages.length === 0 && <div>- {t("no_images")}</div>
        )}
        {/* Imágenes visibles */}
        {visibleImages.map((img, index) => (
          <ImageItem
            key={index}
            img={img}
            fetchAttachments={fetchAttachments}
            canDelete
          />
        ))}

        {/* Indicador de imágenes ocultas */}
        {hiddenCount === 1 ? (
          <ImageItem
            img={attachments[actualMax - 1]}
            fetchAttachments={fetchAttachments}
            canDelete
          />
        ) : (
          hiddenCount > 0 && (
            <Tooltip title={t("show_more")}>
              <div
                style={{
                  position: "relative",
                  width: imageSize,
                  height: imageSize,
                  cursor: "pointer",
                }}
                onClick={() => setIsExpanded(true)} // Expande al hacer click
              >
                <img
                  src={attachments[actualMax - 1]?.url} // Muestra la siguiente imagen de la lista
                  style={{
                    width: "100%",
                    // height: "100%",
                    objectFit: "cover",
                    borderRadius: "5px",
                    border: "2px solid lightgrey",
                    minHeight: "100%",
                  }}
                />
                {!isExpanded && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Semitransparente
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "18px",
                      fontWeight: "bold",
                      borderRadius: "5px",
                    }}
                  >
                    +{hiddenCount}
                  </div>
                )}
              </div>
            </Tooltip>
          )
        )}
      </div>

      {/* Desplegable con transición suave */}
      <div
        style={{
          maxHeight: isExpanded ? "500px" : "0px", // Ajusta la altura máxima según sea necesario
          overflow: "hidden",
          transition: "max-height 0.5s ease-in-out",
          display: "flex",
          flexWrap: "wrap",
          gap: "1rem",
          width: "100%",
          marginTop: isExpanded ? "10px" : "0px",
        }}
      >
        {isExpanded &&
          attachments
            .slice(actualMax + 1)
            .map((img, index) => (
              <ImageItem
                key={index}
                img={img}
                fetchAttachments={fetchAttachments}
                canDelete
              />
            ))}
      </div>
    </div>
  );
};

const ImageItem = ({ img, fetchAttachments, canDelete }) => {
  const { t } = useTranslation("main");
  const [hovered, setHovered] = useState(false);
  const [open, setOpen] = useState(false);
  const [imageError, setImageError] = useState(false);
  const imageSizePx = 80;

  const handleDelete = async () => {
    Confirm.show(
      t("delete_attachment_title"),
      t("delete_attachment_body"),
      t("yes"),
      t("no"),

      async () => {
        const toast_id = toast.loading(`${t("deleting_image")}...`, {
          position: "top-right",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        await deleteAttachment(img.uuid);

        toast.update(toast_id, {
          render: t("image_deleted_successfully"),
          type: "success",
          isLoading: false,
          autoClose: 5000,
        });

        fetchAttachments();
      },
      () => {},
      {}
    );
  };

  return (
    <>
      <div
        style={{
          position: "relative",
          width: `${imageSizePx}px`,
          height: `${imageSizePx}px`,
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div
          style={{
            // width: "100%",
            // height: "100%",
            // objectFit: "cover",
            // borderRadius: "5px",
            // border: "2px solid lightgrey",
            // cursor: "pointer",
            height: "100%",
          }}
        >
          {imageError ? (
            // {false ? (
            <Tooltip title={t("cannot_display_image")}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "5px",
                  border: "2px solid lightgrey",
                  // cursor: "pointer",
                  minHeight: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ImageNotSupportedIcon />
              </div>
            </Tooltip>
          ) : (
            <Tooltip title={t("expand_image")}>
              <img
                src={img.url}
                alt="Preview"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "5px",
                  border: "2px solid lightgrey",
                  cursor: "pointer",
                  minHeight: "100%",
                }}
                onClick={() => setOpen(true)}
                onError={() => setImageError(true)} // Oculta la imagen si hay error
              />
            </Tooltip>
          )}
        </div>

        {hovered && (
          <div
            style={{
              position: "absolute",
              top: 4,
              right: 4,
              display: "flex",
              gap: "0.5rem",
            }}
          >
            <Tooltip title={t("download_image")}>
              <IconButton
                className="deleteImageIconButton mapButton"
                style={{
                  // position: "absolute",
                  // top: 4,
                  // right: 4,
                  height: "2rem",
                  width: "2rem",
                }}
                sx={{ padding: "4px !important" }}
                onClick={() => window.open(img.url)}
              >
                <DownloadIcon />
              </IconButton>
            </Tooltip>
            {canDelete && (
              <Tooltip title={t("delete_image")}>
                <IconButton
                  className="deleteImageIconButton mapButton"
                  style={{
                    // position: "absolute",
                    // top: 4,
                    // right: 4,
                    height: "2rem",
                    width: "2rem",
                  }}
                  sx={{ padding: "4px !important" }}
                  onClick={handleDelete}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            )}
          </div>
        )}
      </div>

      {/* Modal para mostrar la imagen en grande */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 16,
              right: 16,
              display: "flex",
              gap: "0.5rem",
            }}
          >
            <Tooltip title={t("download_image")}>
              <IconButton
                onClick={() => window.open(img.url)}
                sx={{
                  // position: "absolute",
                  // top: 16,
                  // right: 16,
                  color: "white",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                  },
                }}
              >
                <DownloadIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={t("close_image")}>
              <IconButton
                onClick={() => setOpen(false)}
                sx={{
                  // position: "absolute",
                  // top: 16,
                  // right: 16,
                  color: "white",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
          <Tooltip title={t("close_image")} followCursor={true}>
            <img
              src={img.url}
              alt="Expanded View"
              style={{
                maxWidth: "80vw",
                maxHeight: "80vh",
                objectFit: "contain",
                borderRadius: "10px",
                cursor: "pointer",
              }}
              onClick={() => setOpen(false)}
            />
          </Tooltip>
        </Box>
      </Modal>
    </>
  );
};
